import React from "react";
import ReactPlayer from "react-player";

export default class VideoPlayer extends React.Component {
  state = {
    playingVideo: false,
  };
  playVideo() {
    // You can use the play method as normal on your video ref
    this.setState({ playingVideo: true });
  }

  pauseVideo(type) {
    // Pause as well
    this.refs.vidRef.getInternalPlayer().pauseVideo();
    this.setState({ playingVideo: false });
    if (type === "pause") {
    } else {
    }
  }

  // You can pass your function references to your child components as props (here passing down to the Buttons component)
  render() {
    const { url } = this.props;
    return (
      <ReactPlayer
        url={url}
        width="100%"
        pip={true}
        ref="vidRef"
        controls={true}
        playing={this.state.playingVideo}
        config={{
          youtube: {
            playerVars: { showinfo: 1, rel: 0, modestbranding: 1 },
          },
        }}
      />
    );
  }
}
